import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-responsive-ui';
import Conversation from './conversation';
import Guardians from '../components/guardians';

class ConversationsList extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.props = props
        this.createChannel = this.createChannel.bind(this)

    }

    render() {
        return (
            <div className="conversation-list-wrapper">
                <div className="conversation-list-container">
                    <Button className="new-conversation-button" action={() => this.setState({ showContactList: true })}>
                        New conversation
                        </Button>
                    {
                        this.state && this.state.showContactList && <Guardians createChannel={this.createChannel} moduleType="MESSENGER_LIST" {...this.props} />
                    }
                    <div className="conversation-list">
                        {

                            this.props.channels && this.props.channels.map((item, key) => (
                                <div className="conversation-container" key={key}>
                                    {this.state && <Conversation getChannels={this.props.getChannels} channel={item} deleteChannel={this.props.deleteChannel} channelSelected={this.props.channelSelected} />}
                                </div>
                            ))
                        }
                    </div>

                </div>
            </div>
        )
    }

    createChannel(user) {
        // uniqueName = creator&invited
        this.props.chatClient
            .createChannel({
                uniqueName: `${localStorage.getItem('uid')}&${user.uid}`,
                friendlyName: `${localStorage.getItem('name')}&${user.name}`,
            })
            .then(function (channel) {
                channel.invite(user.uid)
                channel.join()
                this.props.channelSelected(channel)
                this.setState({ showContactList: false })
            }.bind(this));
    }

    getDisplayName(channel) {
        if (channel.uniqueName.split('&')[0] == localStorage.getItem('uid')) {
            return channel.friendlyName.split('&')[1]
        } else if (channel.friendlyName && channel.friendlyName.split('&')) {
            return channel.friendlyName.split('&')[0]
        } else if (channel.friendlyName) {
            return channel.friendlyName
        } else {
            return channel.uniqueName
        }

    }

    itemSelected(channel) {
        this.props.channelSelected(channel)
    }

}

ConversationsList.propTypes = {
    history: PropTypes.object,
    showContactList: PropTypes.bool,
    channels: PropTypes.array,
    channel: PropTypes.object,
    channelSelected: PropTypes.func,
    deleteChannel: PropTypes.func,
    updateConversationList: PropTypes.func,
    activeChannel: PropTypes.object,
    getChannels: PropTypes.func,
    chatClient: PropTypes.object,
};
export default ConversationsList;


// WEBPACK FOOTER //
// ./src/view/conversationsList.js